export default __webpack_public_path__ + "static/82774-49dd0cf7cab70163a1efa4c68fc99ad8.jpg";